import { useState, useEffect, useRef, useCallback } from 'react'
import { useAuth } from '../context/AuthContext'
import { supabase } from '../supabase'
import { useNavigate } from 'react-router-dom'
import Topbar from '../components/Topbar'

const APP_ID       = '2111443372750076'
const REDIRECT_URI = 'https://dsnxhqhuigevnhbgcpvh.supabase.co/functions/v1/fb-oauth-callback'
const SCOPES       = 'pages_show_list,pages_messaging,pages_read_engagement,pages_manage_metadata'

function Icon({ path, size = 16, color = 'currentColor', sw = 1.8 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round">
      <path d={path} />
    </svg>
  )
}

const IC = {
  fb:       'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z',
  send:     'M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z',
  image:    'M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12',
  inbox:    'M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
  settings: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z',
  link:     'M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14',
  order:    'M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z',
  refresh:  'M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15',
  live:     'M15 10l4.553-2.069A1 1 0 0121 8.82v6.36a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z',
  x:        'M6 18L18 6M6 6l12 12',
  check:    'M5 13l4 4L19 7',
  alert:    'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z',
  user:     'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z',
  message:  'M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z',
}

const inp = {
  width: '100%', border: '1px solid var(--border)', borderRadius: '9px',
  padding: '9px 12px', fontSize: '12.5px', outline: 'none',
  background: 'var(--bg-card)', color: 'var(--text-primary)',
  fontFamily: 'Space Grotesk, sans-serif', boxSizing: 'border-box',
}

function timeAgo(dateStr) {
  const diff = Math.floor((Date.now() - new Date(dateStr)) / 1000)
  if (diff < 60)    return `${diff}s ago`
  if (diff < 3600)  return `${Math.floor(diff / 60)}m ago`
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`
  return `${Math.floor(diff / 86400)}d ago`
}

// ── Not connected banner ──────────────────────────────────────────────────────
function NotConnected({ onConnect }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 24px', textAlign: 'center' }}>
      <div style={{ width: '72px', height: '72px', borderRadius: '50%', background: '#1877F215', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
        <svg width="32" height="32" viewBox="0 0 24 24" fill="#1877F2"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>
      </div>
      <div style={{ fontSize: '20px', fontWeight: 800, color: 'var(--text-primary)', marginBottom: '8px' }}>Connect your Facebook Page</div>
      <div style={{ fontSize: '13px', color: 'var(--text-muted)', marginBottom: '28px', maxWidth: '400px', lineHeight: 1.7 }}>
        Connect once — then post directly, read your inbox, detect orders automatically, and let Tara run your F-commerce while you sleep.
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', maxWidth: '480px', width: '100%', marginBottom: '28px' }}>
        {[
          { icon: IC.send,  label: 'Post directly to Facebook', sub: 'No more copy-paste' },
          { icon: IC.inbox, label: 'Inbox order detection',     sub: 'Tara spots orders for you' },
          { icon: IC.order, label: 'Auto order creation',       sub: 'Orders created while you sleep' },
          { icon: IC.live,  label: 'Live comment orders',       sub: 'Real-time during FB Lives' },
        ].map(f => (
          <div key={f.label} style={{ padding: '14px', borderRadius: '12px', border: '1px solid var(--border)', background: 'var(--bg-card)', textAlign: 'left' }}>
            <Icon path={f.icon} size={18} color='var(--primary)' sw={1.5} />
            <div style={{ fontSize: '12.5px', fontWeight: 700, color: 'var(--text-primary)', marginTop: '8px' }}>{f.label}</div>
            <div style={{ fontSize: '11.5px', color: 'var(--text-muted)', marginTop: '2px' }}>{f.sub}</div>
          </div>
        ))}
      </div>
      <button onClick={onConnect}
        style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '14px 32px', borderRadius: '12px', background: '#1877F2', border: 'none', fontSize: '14px', fontWeight: 700, color: '#fff', cursor: 'pointer', boxShadow: '0 4px 14px rgba(24,119,242,0.35)' }}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="#fff"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>
        Connect Facebook Page
      </button>
      <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '12px' }}>You'll be redirected to Facebook to authorise PageConnect</div>
    </div>
  )
}

// ── Publisher tab ─────────────────────────────────────────────────────────────
function PublisherTab({ seller }) {
  const [products,     setProducts]     = useState([])
  const [search,       setSearch]       = useState('')
  const [showDD,       setShowDD]       = useState(false)
  const [selected,     setSelected]     = useState(null)
  const [caption,      setCaption]      = useState('')
  const [imageUrl,     setImageUrl]     = useState('')
  const [scheduleFor,  setScheduleFor]  = useState('')
  const [posting,      setPosting]      = useState(false)
  const [posts,        setPosts]        = useState([])
  const [loadingPosts, setLoadingPosts] = useState(true)
  const [postError,    setPostError]    = useState('')
  const [postSuccess,  setPostSuccess]  = useState('')
  const fileRef = useRef()

  useEffect(() => { fetchProducts(); fetchPosts() }, []) // eslint-disable-line

  const fetchProducts = async () => {
    const { data } = await supabase.from('products').select('id,name,product_code,image_url,post_photo_url,sell_price,category').eq('seller_id', seller.id).order('name')
    setProducts(data || [])
  }

  const fetchPosts = async () => {
    setLoadingPosts(true)
    const { data } = await supabase.from('fb_scheduled_posts').select('*').eq('seller_id', seller.id).order('created_at', { ascending: false }).limit(20)
    setPosts(data || [])
    setLoadingPosts(false)
  }

  const handleSelectProduct = (p) => {
    setSelected(p); setSearch(p.name); setShowDD(false)
    if (p.post_photo_url) setImageUrl(p.post_photo_url)
    else if (p.image_url) setImageUrl(p.image_url)
  }

  const handleImageUpload = async (e) => {
    const file = e.target.files?.[0]; if (!file) return
    const path = `${seller.id}/fb-post-${Date.now()}.jpg`
    const { error } = await supabase.storage.from('product-images').upload(path, file, { upsert: true, contentType: file.type })
    if (!error) {
      const { data } = supabase.storage.from('product-images').getPublicUrl(path)
      setImageUrl(data.publicUrl)
    }
    e.target.value = ''
  }

  const handlePost = async () => {
    if (!caption.trim()) return
    setPosting(true); setPostError(''); setPostSuccess('')
    try {
      const { data: post } = await supabase.from('fb_scheduled_posts').insert({
        seller_id: seller.id, product_id: selected?.id || null,
        caption, image_url: imageUrl || null,
        scheduled_for: scheduleFor || null,
        status: scheduleFor ? 'scheduled' : 'draft',
      }).select().single()

      if (!scheduleFor) {
        const { data, error } = await supabase.functions.invoke('fb-publish-post', {
          body: { seller_id: seller.id, scheduled_post_id: post.id, caption, image_url: imageUrl || null, product_id: selected?.id || null }
        })
        if (error || !data?.success) throw new Error(data?.error || 'Post failed')
        setPostSuccess('Posted successfully to ' + (seller.fb_page_name || 'your Facebook page') + '!')
      } else {
        setPostSuccess('Scheduled for ' + new Date(scheduleFor).toLocaleString())
      }
      setCaption(''); setImageUrl(''); setScheduleFor(''); setSelected(null); setSearch('')
      fetchPosts()
    } catch (e) {
      setPostError(e.message || 'Failed to post. Check your Facebook connection.')
    }
    setPosting(false)
  }

  const filteredProducts = products.filter(p =>
    search === '' || p.name.toLowerCase().includes(search.toLowerCase()) || (p.product_code || '').toLowerCase().includes(search.toLowerCase())
  )

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', alignItems: 'flex-start' }} className="fc-grid">
      <div>
        <div className="fc-card" style={{ marginBottom: '16px' }}>
          <div style={{ fontSize: '12px', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: '12px' }}>Compose post</div>
          <div style={{ position: 'relative', marginBottom: '12px' }}>
            <input value={search} onChange={e => { setSearch(e.target.value); setShowDD(true) }} onFocus={() => setShowDD(true)}
              placeholder="Search product (optional)..." style={{ ...inp }}
              onBlur={() => setTimeout(() => setShowDD(false), 150)} />
            {showDD && filteredProducts.length > 0 && (
              <div style={{ position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0, zIndex: 50, background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '10px', boxShadow: 'var(--shadow-lg)', maxHeight: '200px', overflowY: 'auto' }}>
                {filteredProducts.map(p => (
                  <div key={p.id} onMouseDown={() => handleSelectProduct(p)}
                    style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid var(--border)' }}
                    onMouseEnter={e => e.currentTarget.style.background = 'var(--bg-muted)'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    {p.image_url
                      ? <img src={p.image_url} alt={p.name} style={{ width: '32px', height: '32px', borderRadius: '6px', objectFit: 'cover', flexShrink: 0 }} />
                      : <div style={{ width: '32px', height: '32px', borderRadius: '6px', background: 'var(--bg-muted)', flexShrink: 0 }} />}
                    <div>
                      <div style={{ fontSize: '12.5px', fontWeight: 600, color: 'var(--text-primary)' }}>{p.name}</div>
                      <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>{p.product_code}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          <textarea value={caption} onChange={e => setCaption(e.target.value)}
            placeholder="Write your post caption here..." rows={8}
            style={{ ...inp, resize: 'vertical', lineHeight: 1.7, marginBottom: '12px' }}
            onFocus={e => e.target.style.borderColor = 'var(--border-focus)'}
            onBlur={e => e.target.style.borderColor = 'var(--border)'} />
          <input ref={fileRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleImageUpload} />
          {imageUrl ? (
            <div style={{ position: 'relative', marginBottom: '12px' }}>
              <img src={imageUrl} alt="post" style={{ width: '100%', borderRadius: '10px', border: '1px solid var(--border)', display: 'block' }} />
              <button onClick={() => setImageUrl('')} style={{ position: 'absolute', top: '8px', right: '8px', width: '28px', height: '28px', borderRadius: '50%', background: 'rgba(0,0,0,0.6)', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Icon path={IC.x} color='#fff' size={12} sw={2.5} />
              </button>
            </div>
          ) : (
            <button onClick={() => fileRef.current?.click()}
              style={{ width: '100%', padding: '10px', borderRadius: '9px', border: '1.5px dashed var(--border)', background: 'var(--bg-muted)', fontSize: '12.5px', fontWeight: 600, color: 'var(--text-muted)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '7px', marginBottom: '12px' }}>
              <Icon path={IC.image} color='var(--text-muted)' size={14} /> Add photo
            </button>
          )}
          <div style={{ marginBottom: '12px' }}>
            <label style={{ fontSize: '11.5px', fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: '5px' }}>
              Schedule for later <span style={{ fontWeight: 400 }}>optional — leave blank to post now</span>
            </label>
            <input type="datetime-local" value={scheduleFor} onChange={e => setScheduleFor(e.target.value)} style={{ ...inp, cursor: 'pointer' }} />
          </div>
          {postError   && <div style={{ padding: '10px', borderRadius: '8px', background: 'var(--error-light)', border: '1px solid var(--error-border)', fontSize: '12.5px', color: 'var(--error)', marginBottom: '10px' }}>{postError}</div>}
          {postSuccess  && <div style={{ padding: '10px', borderRadius: '8px', background: 'var(--success-light)', border: '1px solid rgba(45,212,176,0.3)', fontSize: '12.5px', color: 'var(--success)', marginBottom: '10px' }}>{postSuccess}</div>}
          <button onClick={handlePost} disabled={posting || !caption.trim()}
            style={{ width: '100%', padding: '11px', borderRadius: '10px', background: posting || !caption.trim() ? 'var(--border)' : '#1877F2', border: 'none', fontSize: '13.5px', fontWeight: 700, color: posting || !caption.trim() ? 'var(--text-muted)' : '#fff', cursor: posting || !caption.trim() ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
            {posting && <div style={{ width: '14px', height: '14px', borderRadius: '50%', border: '2px solid rgba(255,255,255,0.3)', borderTopColor: '#fff', animation: 'fc-spin 0.7s linear infinite' }} />}
            {posting ? 'Posting...' : scheduleFor ? 'Schedule post' : 'Post to Facebook now'}
          </button>
        </div>
        <div style={{ padding: '12px 16px', borderRadius: '10px', background: '#1877F210', border: '1px solid #1877F230', display: 'flex', alignItems: 'center', gap: '10px' }}>
          {seller.fb_page_picture
            ? <img src={seller.fb_page_picture} alt={seller.fb_page_name} style={{ width: '36px', height: '36px', borderRadius: '50%', objectFit: 'cover' }} />
            : <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: '#1877F2', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><svg width="16" height="16" viewBox="0 0 24 24" fill="#fff"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg></div>}
          <div>
            <div style={{ fontSize: '12.5px', fontWeight: 700, color: 'var(--text-primary)' }}>{seller.fb_page_name || 'Facebook Page'}</div>
            <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>Connected · Page ID: {seller.fb_page_id}</div>
          </div>
        </div>
      </div>

      <div>
        <div className="fc-card">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
            <div style={{ fontSize: '12px', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.07em' }}>Post history</div>
            <button onClick={fetchPosts} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px', borderRadius: '6px' }}>
              <Icon path={IC.refresh} size={13} color='var(--text-muted)' />
            </button>
          </div>
          {loadingPosts ? (
            <div style={{ fontSize: '12.5px', color: 'var(--text-muted)', padding: '20px', textAlign: 'center' }}>Loading...</div>
          ) : posts.length === 0 ? (
            <div style={{ fontSize: '12.5px', color: 'var(--text-muted)', padding: '20px', textAlign: 'center' }}>No posts yet — compose your first one</div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', maxHeight: '600px', overflowY: 'auto' }}>
              {posts.map(p => (
                <div key={p.id} style={{ padding: '12px', borderRadius: '9px', border: '1px solid var(--border)', background: 'var(--bg-muted)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '6px' }}>
                    <span style={{ fontSize: '10.5px', fontWeight: 700, padding: '2px 8px', borderRadius: '20px', background: p.status === 'posted' ? 'rgba(45,212,176,0.12)' : p.status === 'scheduled' ? 'rgba(14,165,233,0.12)' : p.status === 'failed' ? 'var(--error-light)' : 'var(--bg-muted)', color: p.status === 'posted' ? 'var(--success)' : p.status === 'scheduled' ? 'var(--primary)' : p.status === 'failed' ? 'var(--error)' : 'var(--text-muted)' }}>{p.status}</span>
                    <span style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
                      {p.posted_at ? new Date(p.posted_at).toLocaleDateString('en-BD', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })
                        : p.scheduled_for ? '🕐 ' + new Date(p.scheduled_for).toLocaleDateString('en-BD', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })
                        : new Date(p.created_at).toLocaleDateString('en-BD', { day: 'numeric', month: 'short' })}
                    </span>
                  </div>
                  <div style={{ fontSize: '12px', color: 'var(--text-primary)', lineHeight: 1.6, marginBottom: '6px', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{p.caption}</div>
                  {p.fb_post_id && (
                    <a href={`https://facebook.com/${p.fb_post_id}`} target="_blank" rel="noreferrer"
                      style={{ fontSize: '11px', color: '#1877F2', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <Icon path={IC.link} size={11} color='#1877F2' /> View on Facebook
                    </a>
                  )}
                  {p.error_message && <div style={{ fontSize: '11px', color: 'var(--error)', marginTop: '4px' }}>Error: {p.error_message}</div>}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

// ── Inbox tab ─────────────────────────────────────────────────────────────────
function groupConversations(logs) {
  const map = {}
  for (const row of logs) {
    const key = row.conversation_id || row.sender_id
    if (!map[key]) {
      map[key] = {
        conversation_id: key,
        sender_id:   row.sender_id,
        sender_name: row.sender_name || 'Customer',
        messages:    [],
        last_ts:     row.created_at,
        unread:      false,
        needs_human: false,
        resolved:    false,
        resolved_at: null,
      }
    }
    map[key].messages.push(row)
    if (row.created_at > map[key].last_ts) map[key].last_ts = row.created_at
    if (!row.read)       map[key].unread      = true
    if (row.needs_human) map[key].needs_human = true
    if (row.resolved)    map[key].resolved    = true
    if (row.resolved_at) map[key].resolved_at = row.resolved_at
  }
  for (const k of Object.keys(map)) {
    map[k].messages.sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
  }
  return Object.values(map).sort((a, b) => new Date(b.last_ts) - new Date(a.last_ts))
}

function InboxTab({ seller }) {
  const navigate = useNavigate()
  const [logs,      setLogs]      = useState([])
  const [loading,   setLoading]   = useState(true)
  const [selected,  setSelected]  = useState(null)
  const [filter,    setFilter]    = useState('all')
  const [stats,     setStats]     = useState(null)
  const [actioning, setActioning] = useState(false)

  const fetchLogs = useCallback(async () => {
    if (!seller?.id) return
    setLoading(true)
    const { data } = await supabase
      .from('tara_inbox_logs')
      .select('*')
      .eq('seller_id', seller.id)
      .order('created_at', { ascending: false })
      .limit(500)
    const all = data || []
    setLogs(all)
    const convIds   = new Set(all.map(r => r.conversation_id || r.sender_id))
    const senderIds = new Set(all.map(r => r.sender_id))
    setStats({
      conversations: convIds.size,
      customers:     senderIds.size,
      messages:      all.length,
      escalations:   all.filter(r => r.needs_human).length,
      orders:        all.filter(r => r.message_out?.includes('pageconnect.io/order')).length,
    })
    setLoading(false)
  }, [seller?.id])

  useEffect(() => { fetchLogs() }, [fetchLogs])

  useEffect(() => {
    if (!seller?.id) return
    const sub = supabase
      .channel('inbox_tab_logs')
      .on('postgres_changes', {
        event: 'INSERT', schema: 'public',
        table: 'tara_inbox_logs',
        filter: `seller_id=eq.${seller.id}`,
      }, () => fetchLogs())
      .subscribe()
    return () => supabase.removeChannel(sub)
  }, [seller?.id, fetchLogs])

  const conversations  = groupConversations(logs)
  const unreadCount    = conversations.filter(c => c.unread && !c.resolved).length
  const humanCount     = conversations.filter(c => c.needs_human && !c.resolved).length
  const filtered       = conversations.filter(c => {
    if (filter === 'unread')      return c.unread && !c.resolved
    if (filter === 'needs_human') return c.needs_human && !c.resolved
    if (filter === 'resolved')    return c.resolved
    return !c.resolved
  })
  const selectedConv = conversations.find(c => c.conversation_id === selected)

  const markRead = async (conv) => {
    const ids = conv.messages.filter(m => !m.read).map(m => m.id)
    if (!ids.length) return
    await supabase.from('tara_inbox_logs').update({ read: true }).in('id', ids)
    setLogs(prev => prev.map(r => ids.includes(r.id) ? { ...r, read: true } : r))
  }

  const handleSelect = async (conv) => {
    setSelected(conv.conversation_id)
    await markRead(conv)
  }

  const handleMarkResolved = async () => {
    if (!selectedConv) return
    setActioning(true)
    const ids = selectedConv.messages.map(m => m.id)
    await supabase.from('tara_inbox_logs').update({ resolved: true, resolved_at: new Date().toISOString(), read: true }).in('id', ids)
    await fetchLogs()
    setSelected(null)
    setActioning(false)
  }

  const handleFlagHuman = async () => {
    if (!selectedConv) return
    setActioning(true)
    const ids    = selectedConv.messages.map(m => m.id)
    const newVal = !selectedConv.needs_human
    await supabase.from('tara_inbox_logs').update({ needs_human: newVal }).in('id', ids)
    await fetchLogs()
    setActioning(false)
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

      {/* Tara Impact stats */}
      {stats && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '10px' }} className="inbox-stats-grid">
          {[
            { label: 'Conversations',    value: stats.conversations, icon: IC.message, color: 'var(--primary)' },
            { label: 'Unique Customers', value: stats.customers,     icon: IC.user,    color: '#7C3AED' },
            { label: 'Messages Handled', value: stats.messages,      icon: IC.inbox,   color: '#0D9488' },
            { label: 'Escalations',      value: stats.escalations,   icon: IC.alert,   color: '#D97706' },
            { label: 'Order Forms Sent', value: stats.orders,        icon: IC.order,   color: 'var(--success)' },
          ].map(s => (
            <div key={s.label} style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '12px', padding: '14px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
                <Icon path={s.icon} size={13} color={s.color} sw={2} />
                <span style={{ fontSize: '10.5px', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>{s.label}</span>
              </div>
              <div style={{ fontSize: '24px', fontWeight: 800, color: 'var(--text-primary)', lineHeight: 1 }}>{s.value.toLocaleString()}</div>
            </div>
          ))}
        </div>
      )}

      {/* Main inbox */}
      <div style={{ display: 'grid', gridTemplateColumns: '300px 1fr', gap: '12px', height: '580px' }} className="fc-inbox-grid">

        {/* Conversation list */}
        <div className="fc-card" style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', padding: 0 }}>
          <div style={{ display: 'flex', gap: '2px', padding: '8px', borderBottom: '1px solid var(--border)', background: 'var(--bg-muted)', flexShrink: 0 }}>
            {[
              { k: 'all',         l: 'Active' },
              { k: 'unread',      l: `Unread${unreadCount > 0 ? ` ${unreadCount}` : ''}` },
              { k: 'needs_human', l: `🚨${humanCount > 0 ? ` ${humanCount}` : ''}` },
              { k: 'resolved',    l: '✓ Done' },
            ].map(f => (
              <button key={f.k} onClick={() => setFilter(f.k)}
                style={{ flex: 1, padding: '5px 3px', borderRadius: '7px', border: 'none', fontSize: '10.5px', fontWeight: 600, cursor: 'pointer', background: filter === f.k ? 'var(--bg-card)' : 'transparent', color: filter === f.k ? 'var(--text-primary)' : 'var(--text-muted)', whiteSpace: 'nowrap' }}>
                {f.l}
              </button>
            ))}
          </div>

          <div style={{ flex: 1, overflowY: 'auto' }}>
            {loading ? (
              <div style={{ padding: '32px', textAlign: 'center' }}>
                <div style={{ width: '20px', height: '20px', borderRadius: '50%', border: '2.5px solid var(--primary)', borderTopColor: 'transparent', animation: 'fc-spin 0.7s linear infinite', margin: '0 auto 10px' }} />
                <div style={{ fontSize: '12.5px', color: 'var(--text-muted)' }}>Loading conversations...</div>
              </div>
            ) : filtered.length === 0 ? (
              <div style={{ padding: '32px', textAlign: 'center' }}>
                <Icon path={IC.inbox} size={28} color='var(--text-muted)' sw={1.2} />
                <div style={{ fontSize: '12.5px', color: 'var(--text-muted)', marginTop: '8px' }}>No conversations here</div>
              </div>
            ) : filtered.map(conv => (
              <div key={conv.conversation_id} onClick={() => handleSelect(conv)}
                style={{ padding: '12px 14px', borderBottom: '1px solid var(--border)', cursor: 'pointer', background: selected === conv.conversation_id ? 'var(--primary-light)' : conv.unread ? 'var(--bg-muted)' : 'var(--bg-card)', borderLeft: `3px solid ${conv.needs_human ? '#D97706' : selected === conv.conversation_id ? 'var(--primary)' : 'transparent'}` }}
                onMouseEnter={e => { if (selected !== conv.conversation_id) e.currentTarget.style.background = 'var(--bg-muted)' }}
                onMouseLeave={e => { if (selected !== conv.conversation_id) e.currentTarget.style.background = conv.unread ? 'var(--bg-muted)' : 'var(--bg-card)' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '3px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', minWidth: 0 }}>
                    {conv.unread && !conv.resolved && <div style={{ width: '7px', height: '7px', borderRadius: '50%', background: 'var(--primary)', flexShrink: 0 }} />}
                    <span style={{ fontSize: '12.5px', fontWeight: conv.unread ? 700 : 500, color: 'var(--text-primary)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {conv.sender_name}
                    </span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flexShrink: 0 }}>
                    {conv.needs_human && <span style={{ fontSize: '9px' }}>🚨</span>}
                    {conv.resolved    && <span style={{ fontSize: '9px', color: 'var(--success)', fontWeight: 700 }}>✓</span>}
                  </div>
                </div>
                <div style={{ fontSize: '11.5px', color: 'var(--text-muted)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginBottom: '3px' }}>
                  {conv.messages[conv.messages.length - 1]?.message_in || conv.messages[conv.messages.length - 1]?.message_out || '—'}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span style={{ fontSize: '10.5px', color: 'var(--text-muted)' }}>{timeAgo(conv.last_ts)}</span>
                  <span style={{ fontSize: '10px', color: 'var(--text-muted)' }}>{conv.messages.length} msg{conv.messages.length !== 1 ? 's' : ''}</span>
                </div>
              </div>
            ))}
          </div>

          <div style={{ padding: '8px 12px', borderTop: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
            <span style={{ fontSize: '11px', color: 'var(--text-muted)' }}>{filtered.length} conversation{filtered.length !== 1 ? 's' : ''}</span>
            <button onClick={fetchLogs} style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px', fontSize: '11.5px', color: 'var(--primary)', fontFamily: 'inherit', fontWeight: 600 }}>
              <Icon path={IC.refresh} size={11} color='var(--primary)' /> Refresh
            </button>
          </div>
        </div>

        {/* Conversation detail */}
        <div className="fc-card" style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', padding: 0 }}>
          {selectedConv ? (
            <>
              {/* Header */}
              <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--border)', background: 'var(--bg-muted)', display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0, flexWrap: 'wrap' }}>
                <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: 'var(--primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: '14px', fontWeight: 700, color: '#fff' }}>
                  {(selectedConv.sender_name || 'C')[0].toUpperCase()}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: '13px', fontWeight: 700, color: 'var(--text-primary)' }}>{selectedConv.sender_name}</div>
                  <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>{selectedConv.messages.length} messages · {timeAgo(selectedConv.last_ts)}</div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0 }}>
                  {selectedConv.needs_human && (
                    <div style={{ padding: '4px 10px', borderRadius: '20px', background: '#FEF3C7', border: '1px solid #FDE68A', fontSize: '11px', fontWeight: 700, color: '#92400E' }}>
                      🚨 Needs human
                    </div>
                  )}
                  <button onClick={handleFlagHuman} disabled={actioning || selectedConv.resolved}
                    style={{ padding: '6px 12px', borderRadius: '8px', border: `1px solid ${selectedConv.needs_human ? 'var(--border)' : '#FDE68A'}`, background: selectedConv.needs_human ? 'var(--bg-muted)' : '#FFFBEB', fontSize: '11.5px', fontWeight: 600, color: selectedConv.needs_human ? 'var(--text-muted)' : '#92400E', cursor: actioning || selectedConv.resolved ? 'not-allowed' : 'pointer', opacity: selectedConv.resolved ? 0.5 : 1 }}>
                    {selectedConv.needs_human ? 'Clear flag' : '🚨 Flag human'}
                  </button>
                  <button onClick={handleMarkResolved} disabled={actioning || selectedConv.resolved}
                    style={{ padding: '6px 12px', borderRadius: '8px', border: '1px solid var(--success-border)', background: 'var(--success-light)', fontSize: '11.5px', fontWeight: 600, color: 'var(--success)', cursor: actioning || selectedConv.resolved ? 'not-allowed' : 'pointer', opacity: selectedConv.resolved ? 0.5 : 1, display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <Icon path={IC.check} size={12} color='var(--success)' sw={2.5} />
                    {selectedConv.resolved ? 'Resolved' : 'Mark resolved'}
                  </button>
                </div>
              </div>

              {/* Chat bubbles */}
              <div style={{ flex: 1, overflowY: 'auto', padding: '16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {selectedConv.messages.map(msg => (
                  <div key={msg.id}>
                    {msg.message_in && (
                      <div style={{ display: 'flex', alignItems: 'flex-end', gap: '8px', marginBottom: msg.message_out ? '8px' : '0' }}>
                        <div style={{ width: '28px', height: '28px', borderRadius: '50%', background: '#E2E8F0', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: '11px', fontWeight: 700, color: 'var(--text-muted)' }}>
                          {(selectedConv.sender_name || 'C')[0].toUpperCase()}
                        </div>
                        <div style={{ maxWidth: '70%' }}>
                          <div style={{ background: 'var(--bg-muted)', borderRadius: '12px 12px 12px 4px', padding: '10px 14px' }}>
                            <div style={{ fontSize: '13px', color: 'var(--text-primary)', lineHeight: 1.6 }}>{msg.message_in}</div>
                          </div>
                          <div style={{ fontSize: '10px', color: 'var(--text-muted)', marginTop: '3px', paddingLeft: '4px' }}>{timeAgo(msg.created_at)}</div>
                        </div>
                      </div>
                    )}
                    {msg.message_out && (
                      <div style={{ display: 'flex', alignItems: 'flex-end', gap: '8px', justifyContent: 'flex-end' }}>
                        <div style={{ maxWidth: '70%' }}>
                          <div style={{ background: 'var(--primary)', borderRadius: '12px 12px 4px 12px', padding: '10px 14px' }}>
                            <div style={{ fontSize: '13px', color: '#fff', lineHeight: 1.6 }}>{msg.message_out}</div>
                          </div>
                          <div style={{ fontSize: '10px', color: 'var(--text-muted)', marginTop: '3px', textAlign: 'right', paddingRight: '4px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '4px' }}>
                            <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                              <path d="M12 2C12 2 12.8 7.5 14.5 9.5C16.2 11.5 22 12 22 12C22 12 16.2 12.5 14.5 14.5C12.8 16.5 12 22 12 22C12 22 11.2 16.5 9.5 14.5C7.8 12.5 2 12 2 12C2 12 7.8 11.5 9.5 9.5C11.2 7.5 12 2 12 2Z" fill="var(--primary)" opacity="0.6" />
                            </svg>
                            Tara · {timeAgo(msg.created_at)}
                          </div>
                        </div>
                        <div style={{ width: '28px', height: '28px', borderRadius: '50%', background: 'var(--primary-light)', border: '1.5px solid var(--primary-border)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                            <path d="M12 2C12 2 12.8 7.5 14.5 9.5C16.2 11.5 22 12 22 12C22 12 16.2 12.5 14.5 14.5C12.8 16.5 12 22 12 22C12 22 11.2 16.5 9.5 14.5C7.8 12.5 2 12 2 12C2 12 7.8 11.5 9.5 9.5C11.2 7.5 12 2 12 2Z" fill="var(--primary)" />
                          </svg>
                        </div>
                      </div>
                    )}
                    {msg.error && (
                      <div style={{ margin: '4px 0', padding: '6px 12px', borderRadius: '8px', background: 'var(--error-light)', border: '1px solid var(--error-border)', fontSize: '11px', color: 'var(--error)' }}>
                        ⚠ Tara error: {msg.error}
                      </div>
                    )}
                  </div>
                ))}
                {selectedConv.resolved && (
                  <div style={{ textAlign: 'center', padding: '10px', borderRadius: '10px', background: 'var(--success-light)', border: '1px solid var(--success-border)', fontSize: '12px', color: 'var(--success)', fontWeight: 600 }}>
                    ✓ Resolved {selectedConv.resolved_at ? timeAgo(selectedConv.resolved_at) : ''}
                  </div>
                )}
              </div>

              {/* Footer */}
              <div style={{ padding: '10px 16px', borderTop: '1px solid var(--border)', background: 'var(--bg-muted)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
                <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
                  Sender ID: <span style={{ fontFamily: 'JetBrains Mono, monospace' }}>{selectedConv.sender_id}</span>
                </div>
                {selectedConv.messages.some(m => m.message_out?.includes('pageconnect.io/order')) && (
                  <button onClick={() => navigate('/orders')}
                    style={{ display: 'flex', alignItems: 'center', gap: '5px', padding: '5px 12px', borderRadius: '8px', background: 'var(--primary)', border: 'none', fontSize: '11.5px', fontWeight: 600, color: '#fff', cursor: 'pointer' }}>
                    <Icon path={IC.order} size={12} color='#fff' sw={2} /> View Orders
                  </button>
                )}
              </div>
            </>
          ) : (
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '10px' }}>
              <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: 'var(--bg-muted)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Icon path={IC.inbox} size={22} color='var(--text-muted)' sw={1.2} />
              </div>
              <div style={{ fontSize: '13px', color: 'var(--text-muted)' }}>Select a conversation</div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

// ── Settings tab ──────────────────────────────────────────────────────────────
function SettingsTab({ seller, onUpdate }) {
  const [autoReply,     setAutoReply]     = useState(seller.fb_auto_reply || false)
  const [orderDetect,   setOrderDetect]   = useState(seller.fb_order_detection !== false)
  const [template,      setTemplate]      = useState(seller.fb_auto_reply_template || 'Thank you for your message! We have received your enquiry and will get back to you shortly. 🙏')
  const [saving,        setSaving]        = useState(false)
  const [saved,         setSaved]         = useState(false)
  const [disconnecting, setDisconnecting] = useState(false)

  const handleSave = async () => {
    setSaving(true)
    await supabase.from('sellers').update({
      fb_auto_reply:          autoReply,
      fb_order_detection:     orderDetect,
      fb_auto_reply_template: template,
    }).eq('id', seller.id)
    setSaving(false); setSaved(true)
    setTimeout(() => setSaved(false), 2000)
    onUpdate()
  }

  const handleDisconnect = async () => {
    if (!window.confirm('Disconnect your Facebook Page? Auto-replies and order detection will stop.')) return
    setDisconnecting(true)
    await supabase.from('sellers').update({
      fb_page_id: null, fb_page_token: null, fb_page_name: null,
      fb_page_picture: null, fb_connected_at: null,
    }).eq('id', seller.id)
    setDisconnecting(false)
    onUpdate()
  }

  const Toggle = ({ val, setVal, label, sub }) => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 16px', background: 'var(--bg-muted)', borderRadius: '10px' }}>
      <div>
        <div style={{ fontSize: '13px', fontWeight: 600, color: 'var(--text-primary)' }}>{label}</div>
        {sub && <div style={{ fontSize: '11.5px', color: 'var(--text-muted)', marginTop: '2px', lineHeight: 1.6 }}>{sub}</div>}
      </div>
      <button onClick={() => setVal(v => !v)}
        style={{ width: '42px', height: '24px', borderRadius: '12px', background: val ? 'var(--success)' : 'var(--border)', border: 'none', cursor: 'pointer', position: 'relative', transition: 'background 0.2s', flexShrink: 0, marginLeft: '16px' }}>
        <div style={{ position: 'absolute', top: '3px', left: val ? '21px' : '3px', width: '18px', height: '18px', borderRadius: '50%', background: '#fff', transition: 'left 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }} />
      </button>
    </div>
  )

  return (
    <div style={{ maxWidth: '600px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
      <div className="fc-card">
        <div style={{ fontSize: '12px', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: '12px' }}>Connected page</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px', borderRadius: '10px', background: '#1877F210', border: '1px solid #1877F230', marginBottom: '14px' }}>
          {seller.fb_page_picture
            ? <img src={seller.fb_page_picture} alt={seller.fb_page_name} style={{ width: '44px', height: '44px', borderRadius: '50%', objectFit: 'cover' }} />
            : <div style={{ width: '44px', height: '44px', borderRadius: '50%', background: '#1877F2', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><svg width="20" height="20" viewBox="0 0 24 24" fill="#fff"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg></div>}
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '14px', fontWeight: 700, color: 'var(--text-primary)' }}>{seller.fb_page_name || 'Facebook Page'}</div>
            <div style={{ fontSize: '11.5px', color: 'var(--text-muted)' }}>
              Connected {seller.fb_connected_at ? new Date(seller.fb_connected_at).toLocaleDateString('en-BD', { day: 'numeric', month: 'short', year: 'numeric' }) : ''}
            </div>
          </div>
          <button onClick={handleDisconnect} disabled={disconnecting}
            style={{ padding: '7px 14px', borderRadius: '8px', border: '1px solid var(--error-border)', background: 'var(--error-light)', fontSize: '12px', fontWeight: 600, color: 'var(--error)', cursor: 'pointer' }}>
            {disconnecting ? 'Disconnecting...' : 'Disconnect'}
          </button>
        </div>
      </div>

      <div className="fc-card">
        <div style={{ fontSize: '12px', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: '12px' }}>Automation — Tara</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '14px' }}>
          <Toggle val={orderDetect} setVal={setOrderDetect} label="Order detection" sub="Tara reads incoming messages and comments — detects product codes and order intent, creates draft orders automatically" />
          <Toggle val={autoReply}   setVal={setAutoReply}   label="Auto-reply to messages" sub="Tara sends your template reply to every new message within seconds — keeps customers engaged while you're away" />
        </div>
        {autoReply && (
          <div>
            <label style={{ fontSize: '11.5px', fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: '6px' }}>Auto-reply message</label>
            <textarea value={template} onChange={e => setTemplate(e.target.value)} rows={4}
              style={{ ...inp, resize: 'none', lineHeight: 1.7, marginBottom: '10px' }} />
            <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>This message sends automatically to every new inbox message. Facebook's 24-hour reply window applies.</div>
          </div>
        )}
        <button onClick={handleSave} disabled={saving}
          style={{ marginTop: '14px', padding: '10px 24px', borderRadius: '9px', background: saved ? 'var(--success)' : saving ? 'var(--border)' : 'var(--primary)', border: 'none', fontSize: '13px', fontWeight: 700, color: saving ? 'var(--text-muted)' : '#fff', cursor: saving ? 'not-allowed' : 'pointer' }}>
          {saved ? '✓ Saved' : saving ? 'Saving...' : 'Save settings'}
        </button>
      </div>

      <div className="fc-card" style={{ background: 'var(--bg-muted)' }}>
        <div style={{ fontSize: '12px', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: '8px' }}>Webhook endpoint</div>
        <div style={{ fontSize: '11.5px', color: 'var(--text-muted)', marginBottom: '8px' }}>This URL receives real-time events from Facebook — messages, comments, live video orders:</div>
        <div style={{ padding: '8px 12px', borderRadius: '8px', background: 'var(--bg-card)', border: '1px solid var(--border)', fontFamily: 'JetBrains Mono, monospace', fontSize: '11px', color: 'var(--text-primary)', wordBreak: 'break-all' }}>
          https://dsnxhqhuigevnhbgcpvh.supabase.co/functions/v1/fb-webhook
        </div>
      </div>
    </div>
  )
}

// ── Main FacebookConnect ──────────────────────────────────────────────────────
export default function FacebookConnect() {
  const { seller }   = useAuth()
  const [activeTab,   setActiveTab]   = useState('publisher')
  const [sellerData,  setSellerData]  = useState(null)
  const [loading,     setLoading]     = useState(true)

  useEffect(() => {
    fetchSellerData()
    const params = new URLSearchParams(window.location.search)
    if (params.get('connected') === '1') {
      fetchSellerData()
      window.history.replaceState({}, '', window.location.pathname)
    }
    if (params.get('error') === '1') {
      alert('Facebook connection failed — please try again. Make sure you authorise all permissions.')
      window.history.replaceState({}, '', window.location.pathname)
    }
  }, []) // eslint-disable-line

  const fetchSellerData = async () => {
    setLoading(true)
    const { data } = await supabase.from('sellers').select('*').eq('id', seller?.id).single()
    setSellerData(data)
    setLoading(false)
  }

  const handleConnect = () => {
    const state   = seller?.id
    const authUrl = `https://www.facebook.com/v19.0/dialog/oauth?client_id=${APP_ID}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}&scope=${SCOPES}&state=${state}&response_type=code`
    window.location.href = authUrl
  }

  const isConnected = !!sellerData?.fb_page_id

  const TABS = [
    { key: 'publisher', label: 'Publisher', icon: IC.send },
    { key: 'inbox',     label: 'Inbox',     icon: IC.inbox },
    { key: 'settings',  label: 'Settings',  icon: IC.settings },
  ]

  return (
    <div style={{ flex: 1, background: 'var(--bg-page)', overflowX: 'hidden', fontFamily: 'Space Grotesk, sans-serif' }}>
      <Topbar title="Facebook Connect" />
      <style>{`
        @keyframes fc-spin { to { transform: rotate(360deg) } }
        .fc-card { background: var(--bg-card); border: 1px solid var(--border); border-radius: 14px; padding: 18px }
        @media(max-width:900px) {
          .fc-grid { grid-template-columns: 1fr !important }
          .fc-inbox-grid { grid-template-columns: 1fr !important; height: auto !important }
          .inbox-stats-grid { grid-template-columns: repeat(2,1fr) !important }
        }
        @media(max-width:500px) {
          .inbox-stats-grid { grid-template-columns: 1fr !important }
        }
      `}</style>

      <div style={{ padding: '20px 24px', paddingBottom: '60px', maxWidth: '1100px', margin: '0 auto' }}>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' }}>
          <div>
            <div style={{ fontSize: '22px', fontWeight: 800, color: 'var(--text-primary)', letterSpacing: '-0.4px', marginBottom: '4px' }}>Facebook Connect</div>
            <div style={{ fontSize: '13px', color: 'var(--text-muted)' }}>
              {isConnected
                ? `Connected to ${sellerData?.fb_page_name || 'your page'} — Tara is watching your inbox`
                : 'Connect your Facebook page to post, read messages and detect orders automatically'}
            </div>
          </div>
          {isConnected && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 14px', borderRadius: '20px', background: 'rgba(45,212,176,0.1)', border: '1px solid rgba(45,212,176,0.3)' }}>
              <div style={{ width: '7px', height: '7px', borderRadius: '50%', background: 'var(--success)' }} />
              <span style={{ fontSize: '12px', fontWeight: 700, color: 'var(--success)' }}>Connected</span>
            </div>
          )}
        </div>

        {loading ? (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '60px' }}>
            <div style={{ width: '24px', height: '24px', borderRadius: '50%', border: '2.5px solid var(--primary)', borderTopColor: 'transparent', animation: 'fc-spin 0.7s linear infinite' }} />
          </div>
        ) : !isConnected ? (
          <NotConnected onConnect={handleConnect} />
        ) : (
          <>
            <div style={{ display: 'flex', gap: '4px', marginBottom: '20px', padding: '4px', borderRadius: '12px', background: 'var(--bg-muted)', width: 'fit-content' }}>
              {TABS.map(tab => (
                <button key={tab.key} onClick={() => setActiveTab(tab.key)}
                  style={{ display: 'flex', alignItems: 'center', gap: '7px', padding: '9px 18px', borderRadius: '9px', border: 'none', fontSize: '13px', fontWeight: 600, cursor: 'pointer', background: activeTab === tab.key ? 'var(--bg-card)' : 'transparent', color: activeTab === tab.key ? 'var(--text-primary)' : 'var(--text-muted)', boxShadow: activeTab === tab.key ? 'var(--shadow-sm)' : 'none', transition: 'all 0.15s', fontFamily: 'inherit' }}>
                  <Icon path={tab.icon} size={14} color={activeTab === tab.key ? 'var(--primary)' : 'var(--text-muted)'} sw={2} />
                  {tab.label}
                </button>
              ))}
            </div>

            {activeTab === 'publisher' && <PublisherTab seller={sellerData} />}
            {activeTab === 'inbox'     && <InboxTab seller={sellerData} />}
            {activeTab === 'settings'  && <SettingsTab seller={sellerData} onUpdate={fetchSellerData} />}
          </>
        )}
      </div>
    </div>
  )
}